<template>
    <div>
        <template v-if="loaded">
            <rkm-form show-legend>
                <rkm-area title="Dados da requisição">
                    <rkm-form ref="Form">
                        <rkm-row>
                            <rkm-col cols="4">
                                <rkm-form-select
                                    :disabled="model.finalizada"
                                    :options="form.requisicao.unidades"
                                    :validations="validations.unidade"
                                    label="Unidade"
                                    show-default-option
                                    textField="nomeFantasia"
                                    v-model="form.requisicao.unidadeId"
                                    valueField="id"
                                />
                            </rkm-col>

                            <rkm-col cols="4">
                                <rkm-form-select
                                    :disabled="model.finalizada || !form.requisicao.unidadeId"
                                    :options="infraestruturas"
                                    :validations="validations.infraestrutura"
                                    label="Local de atendimento"
                                    show-default-option
                                    textField="nome"
                                    v-model="form.requisicao.infraestruturaId"
                                    valueField="id"
                                />
                            </rkm-col>

                            <rkm-col cols="4">
                                <rkm-form-select
                                    :disabled="model.finalizada || !form.requisicao.infraestruturaId"
                                    :options="centrosCusto"
                                    :validations="validations.centroCusto"
                                    label="Setor"
                                    show-default-option
                                    textField="setorNome"
                                    v-model="model.requisicao.centroCustoId"
                                    valueField="id"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="6">
                                <rkm-form-input-autocomplete
                                    :disabled="model.finalizada || !form.requisicao.infraestruturaId"
                                    :repository="repositories.usuario"
                                    :request-query-string-params="autocompleteQueryStringParams.usuario"
                                    :search-fields="autocompleteFields.usuario"
                                    :validations="validations.usuario"
                                    label="Usuário"
                                    uppercase
                                    v-model="model.requisicao.usuario"
                                    text-field="cidadaoNome"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <rkm-form-input
                                    :disabled="additionals.isNumeroRequisicaoAutomatico || model.finalizada"
                                    :validations="validations.numero"
                                    label="Número"
                                    number
                                    v-model="model.requisicao.numero"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <rkm-form-date-picker
                                    :disabled="model.finalizada"
                                    :max-date="additionals.dataAtual"
                                    :validations="validations.data"
                                    label="Data"
                                    right
                                    v-model="model.requisicao.data"
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-form>
                </rkm-area>

                <Material
                    :data="{ additionals, model }"
                    ref="Material"
                />
            </rkm-form>
        </template>
    </div>
</template>

<script>
// Components.
import Material from './components/material/Index'

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, error, stringCase, object, data, file } from '@/mixins'

// Moment.
import moment from 'moment'

export default {
    components: { Material },
    computed: {
        autocompleteFields() {

            return {
                usuario: [
                    { key: 'cadastro_cidadao.nome', searchable: true },
                ],
            }
        },
        autocompleteQueryStringParams() {

            return {
                usuario: {
                    infraestrutura_id: this.form.requisicao.infraestruturaId
                }
            }
        },
        validations() {

            return {
                unidade: {
                    required: true,
                },
                infraestrutura: {
                    required: true,
                },
                centroCusto: {
                    required: true,
                },
                usuario: {
                    required: true,
                },
                numero: {
                    required: true,
                    max: 20,
                },
                data: {
                    required: true,
                },
            }
        },
        infraestruturas() {

            if (this.form.requisicao.unidadeId) {

                return this.form.requisicao.unidades
                    .find(u => u.id === this.form.requisicao.unidadeId).infraestruturas
            }

            return []
        },
        centrosCusto() {

            if (this.form.requisicao.infraestruturaId && this.infraestruturas.length > 0) {

                const infrasestrutura = this.infraestruturas.find(i => i.id === this.form.requisicao.infraestruturaId)

                return infrasestrutura ? infrasestrutura.centrosCusto : []
            }

            return []
        }
    },
    created() {

        this.repositories = {
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
            saida: this.getConectaSusRepository('almoxarifado.saida'),
            impressao: this.getConectaSusRepository('impressao.almoxarifado'),
        }

        this.load()
    },
    data: () => ({
        additionals: null,
        form: null,
        loaded: false,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            const request = this.id
                ? this.repositories.saida.edit(this.id)
                : this.repositories.saida.create()

            request
                .then(({ data }) => {

                    if (data.model.requisicao.data) {

                        data.model.requisicao.data = moment(data.model.requisicao.data, 'DD/MM/YYYY').toDate()
                    }

                    this.additionals = data.additionals
                    this.form = data.form
                    this.model = data.model

                    this.addWatchers()
                    this.$emit('model-load', this.model)

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        addWatchers() {

            this.$watch('form.requisicao.unidadeId', function () {

                this.form.requisicao.infraestruturaId = null
            })

            this.$watch('form.requisicao.infraestruturaId', function () {

                this.model.requisicao.centroCustoId = null
                this.model.requisicao.usuario = null
            })

            this.$watch('infraestruturas', function (infraestruturas) {

                if (infraestruturas.length === 1) {

                    this.form.requisicao.infraestruturaId = infraestruturas[0].id
                }
            })

            this.$watch('centrosCusto', function (centrosCusto) {

                if (centrosCusto.length === 1) {

                    this.model.requisicao.centroCustoId = centrosCusto[0].id
                }
            })
        },
        finalizar() {

            this.showConfirmation(
                'Após finalizar não será mais possível alterar os dados da requisição. Deseja continuar?',
                async () => this.save(true)
            )
        },
        save(finalizar, imprimir = false) {

            if (finalizar) {

                this.handleSave(true, imprimir)

                return
            }

            this.showConfirmation(
                `Ao salvar a saída sem finalizar, o estoque de cada material incluído não será reservado, podendo não
                    estar disponível ao finalizar a saída futuramente. Deseja realmente continuar?`,
                async () => this.handleSave(false, imprimir)
            )
        },
        handleSave(finalizar, imprimir) {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    if (this.model.itens.length === 0) {

                        this.showValidationNotification('Obrigatório incluir pelo menos um material.')

                        return;
                    }

                    this.setLoading()

                    const request = this.id
                        ? this.repositories.saida.update(this.id, this.prepareData(finalizar))
                        : this.repositories.saida.store(this.prepareData(finalizar))

                    request
                        .then(({ data }) => {

                            this.showSaveNotification()

                            if (imprimir) {

                                this.print(data.id).then(() => this.$emit('save', data))
                            }
                            else {

                                this.$emit('save', data)
                            }
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData(finalizar) {

            const data = this.clone(this.model)

            data.finalizada = finalizar

            this.createIdKeysToObject(data.requisicao, [
                'usuario',
            ])

            this.formateDates(data.requisicao, [
                'data',
            ], 'DD/MM/YYYY')

            data.itens.map(item => {

                item.entradaItens = item.entradaItens.filter(i => i.quantidadeSaida > 0)

                this.createIdKeysToObject(item, [
                    'material',
                ])
            })

            return this.camelObjectKeysToSnakeRecursive(data)
        },
        print(saidaId) {

            this.setLoading()

            return this.repositories.impressao.saida(saidaId)
                .then(response => {

                    this.openFile(response.data, response.headers['content-type'])
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        }
    },
    mixins: [ repository, error, stringCase, object, data, file ],
    props: {
        id: { type: Number }
    },
}
</script>